__turbopack_context__.v({
  "link": "y3SChq_link",
});
